export default function ParseCookieHelperService() {

  function getCookie(name: string) {
    console.log("All cookies:", document.cookie);
    let cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        console.log("Cookie Name: ", cookiePair[0].trim(), "Cookie Value: ", cookiePair[1]);
  
        if (name === cookiePair[0].trim()) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null; // Consider returning undefined or an empty string to signify no cookie found
}
  return {
    getCookie
  }
}